import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

/**
 * Безопасно преобразует HTML-строку в React-элементы, пригодные для рендеринга в DOM.
 * Использует DOMPurify для очистки HTML от потенциально опасного или нежелательного содержимого,
 * а затем парсит результат в React-элементы с помощью html-react-parser.
 *
 * ⚠️ Не предназначено для использования с @react-pdf/renderer. Работает только в браузерном DOM.
 *
 * @param {string} value - HTML-строка, содержащая разметку.
 * @returns {React.ReactNode} - Безопасные React-элементы для рендеринга в браузере.
 *
 * @example
 * htmlParser('<p>Hello <strong>world</strong></p>');
 * // Вернёт: React-элемент: <p>Hello <strong>world</strong></p>
 */

export const htmlParser = (value: string) => parse(DOMPurify.sanitize(value));
